import { Box, BoxProps, Typography, TypographyProps } from '@mui/material'
import { FC } from 'react'

interface EllipseTextProps {
  label: string
  labelProps?: BoxProps
  rootProps?: TypographyProps
}

export const EllipseText: FC<EllipseTextProps> = ({ label, labelProps, rootProps }) => {
  return (
    <Typography
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      {...(rootProps || {})}
    >
      <Box component="span" fontSize="0.75rem" color="secondary" {...(labelProps || {})}>
        {label}
      </Box>
    </Typography>
  )
}
